import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let organization = data[0]
    return {
      name:
        organization.level === 'location'
          ? organization.parent.name
          : organization.name,
    }
  }, [data]) //eslint-disable-line
}
